import { render, staticRenderFns } from "./DocumentoComponent.vue?vue&type=template&id=cf09c4b0&"
import script from "./DocumentoComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentoComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoComponent.vue?vue&type=style&index=0&id=cf09c4b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports